import { render } from "./CarouselOfFloorplans.vue?vue&type=template&id=ab23aac6&scoped=true"
import script from "./CarouselOfFloorplans.vue?vue&type=script&lang=js"
export * from "./CarouselOfFloorplans.vue?vue&type=script&lang=js"

import "./CarouselOfFloorplans.vue?vue&type=style&index=0&id=ab23aac6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab23aac6"]])

export default __exports__